const brandBase = `${process.env.PUBLIC_URL || ''}/brand`;

export const brandAssets = {
  logo: `${brandBase}/dealskout-logo.png`,
  mark: `${brandBase}/dealskout-mark.png`,
  icon: `${brandBase}/dealskout-icon.png`,
} as const;

export const brandAlt = {
  logo: 'DealSkout logo, detective mascot with a magnifying glass over a house',
  mark: 'DealSkout',
} as const;
